import { createFileRoute } from '@tanstack/react-router';

import { RouteGuard } from '../../lib/route-guard.js';
import { ManufacturingOrderCreatePage } from '../../modules/manufacturing/manufacturing-order-create-page.js';

export const Route = createFileRoute('/manufacturing/new')({
  component: NewManufacturingOrderPage,
});

// eslint-disable-next-line react-refresh/only-export-components
function NewManufacturingOrderPage() {
  return (
    <RouteGuard route="/manufacturing/new">
      <ManufacturingOrderCreatePage />
    </RouteGuard>
  );
}
